import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'oldPassword',
      type: 'password',
      label: '老密码',
      placeholder: '请输入老密码',
      rules: { required: true, message: '老密码是必传的', trigger: 'blur' }
    },
    {
      field: 'password',
      type: 'password',
      label: '新密码',
      placeholder: '请输入新密码',
      rules: [
        { required: true, message: '新密码是必传的', trigger: 'blur' },
        { min: 8, max: 20, message: '长度在 8 到 20 个字符', trigger: 'blur' }
      ]
    },
    {
      field: 'confirmPassword',
      type: 'password',
      label: '确认密码',
      placeholder: '请输入确认密码',
      rules: [{ required: true, message: '确认密码是必传的', trigger: 'blur' }]
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
